(() => {
  const prepareImages = (root) => {
    root.querySelectorAll('.themar-home__image-swap').forEach((link) => {
      const image = link.querySelector('.themar-home__image-secondary');
      if (!image || image.dataset.themarHoverBound) return;
      image.dataset.themarHoverBound = 'true';
      const enableSwap = () => {
        if (image.naturalWidth > 0) {
          link.classList.add('themar-home__image-swap--ready');
        }
      };
      image.addEventListener('load', enableSwap, { once: true });
      image.addEventListener('error', () => {
        link.classList.remove('themar-home__image-swap--ready');
      });
      if (image.complete) enableSwap();
    });
  };
  prepareImages(document);
  document.addEventListener('shopify:section:load', (event) => {
    prepareImages(event.target);
  });
})();
